const order = {
  pending: 0,
  to_do: 1,
  done: 2,
};
const ProgressBar = ({ data = {} }) => {
  if (Object.keys(data).length < 1) {
    return null;
  }
  return (
    <div className="status-progress-bar-container">
      <div className="status-progress-bar">
        {Object.keys(data).sort((a, b) => order[a] - order[b]).map((key) => (
          <div
            key={key}
            className={`status-progress-fill ${key}`}
            style={{ width: `${data[key]}%` }}
          />
        ))}
      </div>
    </div>
  );
};

export default ProgressBar;
